<template>
  <section class="rounded-sm bg-white p-4 shadow not-last-of-type:mb-4 sm:p-8">
    <slot />
  </section>
</template>
